import { Popover } from '@chakra-ui/react';
import { FilterPopoverButton, FilterPopoverContent } from './FilterPopover';
import { CheckboxFilter } from './CheckboxFilter';
import { ICourse } from '@/shared/ICourse';
import { CourseSegmentOptions, DefaultCourseSegment } from './CourseSegmentOptions';

export const CheckboxFilterSegment = (props: {
  allCourses: ICourse[];
  value: string[] | undefined;
  onSetFilter: (value: string[] | undefined) => void;
}) => {

  const options = CourseSegmentOptions.map((item) => ({
    label: item.label,    value: item.value,
    count: props.allCourses?.reduce((count, course: ICourse) => ((course.CourseSegment ?? DefaultCourseSegment) === item.value) ? count + 1 : count, 0) ?? 0
  })).filter(option => option.count > 0); // Only show options that exist

  const hasSelection = props.value !== undefined && props.value.length > 0;

  return (
    <Popover isLazy placement="bottom-start">
      <FilterPopoverButton label="Segment" selected={hasSelection} />
      <FilterPopoverContent>
        <CheckboxFilter
          hideLabel
          value={props.value}
          onChange={(v) => props.onSetFilter(v)}
          options={options} />
      </FilterPopoverContent>
    </Popover>
  );
};
